import { setActionStatusPending, setActionStatusSuccess, setActionStatusError } from '@/store/helpers';

import {
  SET_LOADED_BRP_SETTINGS,
  SET_HAS_DEFAULT_BRP_SETTING,
  SET_LOADED_PRP_SETTINGS,
  SET_HAS_DEFAULT_PRP_SETTING
} from './mutationTypes';

export default {

  [SET_LOADED_BRP_SETTINGS](state, brpSettings) {
    state.brpSettings = brpSettings;
  },

  [SET_HAS_DEFAULT_BRP_SETTING](state) {
    state.noDefaultBrpSetting = false;
  },

  [SET_LOADED_PRP_SETTINGS](state, prpSettings) {
    state.prpSettings = prpSettings;
  },

  [SET_HAS_DEFAULT_PRP_SETTING](state) {
    state.noDefaultPrpSetting = false;
  },

  setActionStatusPending,
  setActionStatusSuccess,
  setActionStatusError,
};